module.exports = __webpack_public_path__ + "img/admin-sign-up.9fd0e538.png";